import './FeedBack.css'
import {useState} from "react";
const FeedBack = () => {
    const [email, setEmail] = useState('');
    const [message, setMessage] = useState('');

    const handleSubmit = (e) => {
        e.preventDefault();
        // Logic to handle form submission goes here
        console.log('Feedback submitted:', {  email, message });
    };

    const nextStep = () => {
    }

    return (
        <div className={"h-feedback container animate"} id={"feedback"}>
            <div className={"row"}>
                <div className={"col-md-5 col-lg-5 col-xs-12 col-sm-12"}>
                    <h2 className={"contact-us"}>Contactez-nous dès aujourd'hui !</h2>
                    <p className={"feedback-accroch"}>Nous sommes ici pour vous assister. Veuillez remplir le formulaire pour nous envoyer votre message. Notre équipe vous répondra rapidement.</p>
                    <p className={"feedback-accroch"}>
                        Merci de votre intérêt pour <strong>Agri-Tech Solution</strong>. <i>"Ensemble, transformons l'agriculture pour un avenir meilleur."</i>
                    </p>
                </div>
                <div className={"col-md-1 col-lg-1 col-xs-12 col-sm-12"}></div>
                <div className={"col-md-6 col-lg-6 col-xs-12 col-sm-12"}>
                    <div className="feedback-form-container">
                        <h2>Contactez-nous</h2>

                        <form className="feedback-form" onSubmit={handleSubmit}>
                            <div className="form-group">
                                <label htmlFor="email" className={"email-input"}>Email</label>
                                <input
                                    type="email"
                                    id="email"
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                    required
                                />
                            </div>
                            <div className={"form-group h-message next"}>
                                <label htmlFor="message">Message</label>
                                <textarea
                                    id="message"
                                    value={message}
                                    onChange={(e) => setMessage(e.target.value)}
                                    required
                                ></textarea>
                            </div>
                            <button type="submit" className={"submit-button  next" } onClick={nextStep}>Envoyer</button>

                        </form>

                    </div>
                </div>
            </div>

        </div>

    );
}

export default FeedBack;